import { Lock, LockOpen, LockPerson } from '@mui/icons-material'
import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Divider,
  Tooltip,
  Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import { getLocaleFromFullDate } from 'common/libs/fechas'
import Icon from 'icons/Icons'
import { useNavigate } from 'react-router-dom'
import ThemeManager from 'theming/ThemeManager'

const HojasGastosCard = ({
  data: hojaGasto,
  clickEnabled = true,
  extended = false,
  amountFocus = false,
  forcedAmount = null,
}) => {
  const Theme = new ThemeManager()
  const navigate = useNavigate()

  return (
    <Card
      sx={{ ':hover': { cursor: 'pointer' }, height: '100%', width: '100%' }}
      onClick={() => (clickEnabled ? navigate(`/hojasgasto/${hojaGasto.id}`) : null)}
    >
      <CardActionArea>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flexGrow: 1 }}>
            <CardHeader
              sx={{ paddingBottom: 0 }}
              avatar={
                hojaGasto?.status === '0500' ? (
                  <Tooltip title="Abierta">
                    <LockOpen color="success" />
                  </Tooltip>
                ) : hojaGasto?.status === '1500' ? (
                  <Tooltip title="En validación" color="warning">
                    <LockPerson />
                  </Tooltip>
                ) : (
                  <Tooltip title="Cerrada">
                    <Lock color="error" />
                  </Tooltip>
                )
              }
              title={
                <Box>
                  <Typography variant="h6" align="left">
                    {hojaGasto.d_periodo} {hojaGasto.ejercicio}
                  </Typography>
                </Box>
              }
              subheader={
                <Typography variant="subtitle2" align="left">
                  {hojaGasto.d_tipo}
                </Typography>
              }
            />
            <CardContent sx={{ padding: '0px !important' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'wrap',
                }}
              >
                <Divider sx={{ margin: 2 }} />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    mb: 1,
                    paddingX: 2,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                    <Icon icon="fi-rr-check-in-calendar" size="x-large" />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography variant="caption" display="block">
                        Fecha inicio
                      </Typography>
                      <Typography variant="body1">
                        {getLocaleFromFullDate(hojaGasto.fecha_inicio, false)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                    <Icon icon="fi-rr-check-out-calendar" size="x-large" />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography variant="caption" display="block">
                        Fecha fin
                      </Typography>
                      <Typography variant="body1">
                        {getLocaleFromFullDate(hojaGasto.fecha_fin, false)}
                      </Typography>
                    </Box>
                  </Box>
                  {extended && hojaGasto.d_subempresa ? (
                    <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                      <Icon icon="fi-rr-building" size="x-large" />
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="caption" display="block">
                          Subempresa
                        </Typography>
                        <Typography variant="body1">{hojaGasto.d_subempresa}</Typography>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                  {extended && hojaGasto.d_tipo_grupo ? (
                    <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                      <Icon icon="fi-rr-chart-set-theory" size="x-large" />
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="caption" display="block">
                          Grupo
                        </Typography>
                        <Typography variant="body1">{hojaGasto.d_tipo_grupo}</Typography>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
              {amountFocus ? (
                <></>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    justifyContent: 'space-between',
                    background: 'var(--mui-palette-grey-400)',
                    mt: 2,
                    paddingX: 2,
                    paddingY: 1,
                  }}
                >
                  <Typography variant="button" color="white">
                    Total:
                  </Typography>
                  <Typography variant="button" color="white">
                    {hojaGasto.importe ?? '0.00'}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Box>
          {amountFocus ? (
            <Box
              sx={{
                flex: '1 1 20%',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 0,
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                padding: 4,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
              }}
            >
              <Typography>TOTAL</Typography>
              <Typography variant="h1">
                {forcedAmount ? forcedAmount : (hojaGasto.importe ?? 0)}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default HojasGastosCard
